import { render, staticRenderFns } from "./StatBar.vue?vue&type=template&id=57863948"
import script from "./StatBar.vue?vue&type=script&lang=js"
export * from "./StatBar.vue?vue&type=script&lang=js"
import style0 from "./StatBar.vue?vue&type=style&index=0&id=57863948&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports